import { lazy } from 'react';

export const ProviderXCompetitionsXgamesTableLazy = lazy(
  () => import('./ProviderXcompetitionsXgamesTable')
);
